export const GET_USER_PAYMENTS = "GET_USER_PAYMENTS";